import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyDuXbUlrIbKPVOgOYPzMLZ_ciVzVovk4DI",
//   authDomain: "greenhousecakes.firebaseapp.com",
//   projectId: "greenhousecakes",
//   storageBucket: "greenhousecakes.appspot.com",
//   messagingSenderId: "705670123148",
//   appId: "1:705670123148:web:cf8c2bcf27f40cccccb5a9",
//   measurementId: "G-YH3Z1X25KE"
// };
const firebaseConfig = {
  apiKey: "AIzaSyBx4fFaqt28W4jwSEP8xiGCadpEUORV6nU",
  authDomain: "ghc-crm.firebaseapp.com",
  projectId: "ghc-crm",
  storageBucket: "ghc-crm.appspot.com",
  messagingSenderId: "359440603882",
  appId: "1:359440603882:web:a6b831423b39f5f8ef9593",
  measurementId: "G-K091GW7E1Z"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export let db = firebase.firestore();
const storage = firebase.storage();
// Initialize Firebase Authentication and get a reference to the service
export const auth = firebase.auth();
export const authWorkers = firebase.auth();




// WEBPACK FOOTER //
// ./src/firebase/index.js